<template>
  <CustomPage :noTitle="true">
    <div slot="content">
      <div class="mine-container">
        <div class="content" style="padding-bottom: 50px">
          <Header />
          <div class="overview">
            <template v-if="distributionFlag">
              <Level />
              <Wallet />
              <Income />
              <Order />
            </template>
            <template v-else>
              <Order />
              <Wallet />
            </template>
          </div>
        </div>
        <Tabbar />
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomPage from '@/components/custom-page.vue'
import CustomView from '@/components/custom-view.vue'
import Tabbar from '@/components/Tabbar'
import Header from './components/Header'
import Order from './components/Order'
import Wallet from './components/Wallet'
import Level from './components/Level'
import Income from './components/Income'
export default {
  components: {
    CustomPage,
    CustomView,
    Tabbar,
    Header,
    Order,
    Wallet,
    Level,
    Income,
  },
  computed: {
    ...mapGetters(['distributionFlag']),
  },
}
</script>

<style lang="less" scoped>
.overview {
  padding: 12px 20px 0;
}
</style>